import * as React from "react";
import Circle from "../components/Circle";
import {Helmet} from "react-helmet";
import NavigationControls from "./NavigationControls";
import PropTypes from "prop-types";
import RingSizeExplainer from "./RingSizeExplainer";
import {checkProgress} from "../modules/checkProgress";
import {getPageTitle} from "../modules/StyleSurveyHelper";

export default class StyleSurveyRingSizeQuestion extends React.PureComponent {

  static propTypes = {
    "answers": PropTypes.array.isRequired,
    "header": PropTypes.element.isRequired,
    "location": PropTypes.object.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "skip": PropTypes.object,
    "surveyFields": PropTypes.object.isRequired,
    "surveyValues": PropTypes.object.isRequired
  };

  static defaultProps = {
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  constructor (props) {
    super(props);

    this.state = {"modalIsOpen": false};
  }

  componentDidMount = () => {
    checkProgress();
  }

  isRetaking = () => {
    const {"location": {pathname}} = this.props;
    return pathname.includes("retake");
  }

  toggleModal = () => {
    const {modalIsOpen} = this.state;

    this.setState({"modalIsOpen": !modalIsOpen});
  };

  disableNextButton = () => {
    const {surveyValues} = this.props;

    return surveyValues.every(value => value === false);
  }

  render () {
    const {answers, header, location, nextRoute, onAnswer, prevRoute, skip, surveyFields} = this.props;
    const {pathname} = location;
    const {modalIsOpen} = this.state;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {getPageTitle(pathname)}
          </title>
        </Helmet>

        <div className="StyleSurveyRingSizeQuestion">
          {header}
          <div className="StyleSurveyAnswers">
            {answers.map(answer =>
              <div key={answer.prompt}>
                <Circle
                  answer={answer}
                  onAnswer={onAnswer}
                  surveyFields={surveyFields}
                />
              </div>)}
            <p>
              Don&#39;t know your ring size? No worries, you can come back to this later.
            </p>
            {this.isRetaking() &&
              <a
                className="mt16 mb32"
                href="#ring-size-explainer"
                onClick={this.toggleModal}
              >
                Or, use this quick way to find your size.
              </a>
            }
          </div>
          <NavigationControls
            isDisabled={this.disableNextButton()}
            nextRoute={nextRoute}
            onAnswer={onAnswer}
            prevRoute={prevRoute}
            skip={skip}
          />
          <RingSizeExplainer
            clickHandler={this.toggleModal}
            open={modalIsOpen}
          />
        </div>
      </React.Fragment>
    );
  }
}
